import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import { responsiveMobileBreakpoint } from "design-system/src/Components/Grid/_utils/responsiveObserve";
import styled from "styled-components";

export const _AccountOrderHelpModalBody = styled.div(() => {
  return {
    padding: "54px 48px",
    [`@media ${responsiveMobileBreakpoint}`]: {
      padding: "32px 32px",
    },
  };
});

export const _AccountOrderButtonWrapper = styled(FlexBox)<{}>(() => {
  const gradientHeight = 24;
  return {
    width: "100%",
    position: "sticky",
    bottom: "0px",
    background: "white",
    flexDirection: "column",
    // Border trick to fix undesirable border
    border: "1px solid white",

    paddingBottom: 54,
    marginBottom: -54,
    [`@media ${responsiveMobileBreakpoint}`]: {
      paddingBottom: 32,
      marginBottom: -32,
    },

    "&:before": {
      content: '""',
      display: "block",
      background: "linear-gradient(to bottom, transparent, white)",
      height: gradientHeight,
      width: "100%",
      marginBottom: -gradientHeight,
      position: "relative",
      top: -gradientHeight,
    },
  };
});
